/**
 * Quick-add-to-cart for product-card grids (collection, featured collection,
 * search, MWC carousel). Every product in this catalog is its own Shopify
 * product (each size/proof is a separate SKU, not a variant), so a card only
 * ever needs to add one specific variant - no size picker required here.
 */
(function () {
  function updateCartCount(count) {
    var el = document.getElementById('mm-cart-count');
    if (count > 0) {
      if (!el) {
        el = document.createElement('span');
        el.className = 'mm-header__cart-count';
        el.id = 'mm-cart-count';
        var cartLink = document.querySelector('.mm-header__cart');
        if (cartLink) cartLink.insertBefore(el, cartLink.firstChild);
      }
      el.textContent = count;
    } else if (el) {
      el.remove();
    }
  }

  function handleClick(e) {
    var btn = e.currentTarget;
    if (btn.disabled) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js').then(function (res) { return res.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        btn.textContent = 'Added ✓';
        btn.classList.add('is-added');
        setTimeout(function () {
          btn.textContent = originalText;
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 1600);
      })
      .catch(function () {
        btn.textContent = 'Try Again';
        btn.disabled = false;
      });
  }

  function init() {
    document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
      if (btn.dataset.quickAddBound) return;
      btn.dataset.quickAddBound = 'true';
      btn.addEventListener('click', handleClick);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  // Sections re-render inside the theme editor without a full page load.
  document.addEventListener('shopify:section:load', init);
})();
